<template>
  <div class="container-fluid">
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { useAuth0 } from "@auth0/auth0-vue";
import { onBeforeUnmount, watch, onMounted } from "vue";

import store from "../../../store";

const { isLoading } = useAuth0();
const router = useRouter();

const initialCall = () => {
  store.commit('theme/toggleConfigButton', true);
  store.commit('theme/toggleDefaultLayout');
  document.getElementsByTagName("body")[0].classList.remove("bg-gray-100");
};

onBeforeUnmount(() => {
  store.commit('theme/toggleConfigButton', false);
  store.commit('theme/toggleDefaultLayout');
  document.getElementsByTagName("body")[0].classList.add("bg-gray-100");
});

const redirectRoute = () => {
  if (!isLoading.value) {
    router.replace('/dashboards');
  }
};

onMounted(() => {
  redirectRoute();
});

watch(isLoading, (cmpId) => {
  if (!cmpId) {
    redirectRoute();
  }
});

initialCall();
</script>
